module.exports = __webpack_public_path__ + "static/media/G.95cc033e.svg";